import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const Default = () => (
  <div className="relative rounded-md bg-gray-700">
    <Link href="/collections/bundles?handle=bundles" passHref>
      <a className="relative flex h-full w-full flex-col items-center justify-between px-4 pt-4 text-center leading-none text-white lg:px-4 lg:pt-6">
        <div className="flex flex-col items-center gap-2 lg:gap-4">
          <span className="text-base font-extrabold lg:text-lg 2xl:whitespace-nowrap">
            THERE'S MORE TO LOVE
          </span>
          <span className="text-sm">
            Exciting bundles and{<br />} even more savings.
          </span>
          <button
            type="button"
            className="mt-2 rounded-md !bg-teal-500 px-4 py-2 text-xs font-extrabold text-gray-700"
          >
            Shop Bundles
          </button>
        </div>
        <Image
          src={getEdgeUrl(
            'images/hot-deals/bundle-deals-iphone-airpods-applewatch.png',
          )}
          className="flex items-baseline object-contain"
          alt="bundle"
          quality={100}
          width={176}
          height={104}
        />
      </a>
    </Link>
  </div>
);

export default Default;
